import { SidecarBlock as SidecarBlockType } from "~/components/Sidecar/sidecar-schemas";
import { SidecarBlock } from "~/components/Sidecar/SidecarBlock";

export type SidecarBlocksProps = {
  blocks: SidecarBlockType[];
};

export const SidecarBlocks: React.FC<SidecarBlocksProps> = ({
  blocks,
}): JSX.Element | null => {
  if (!blocks?.length) {
    return null;
  }
  const contentBlockComponents = blocks.map((block, i) => {
    const blockIndex = i + 1;
    const blockKey = `${block.acfFcLayout}-${blockIndex}`;

    return (
      <SidecarBlock block={block} blockIndex={blockIndex} key={blockKey} />
    );
  });

  return <>{contentBlockComponents}</>;
};
